import { makeStyles } from "@material-ui/core/styles";

export function useHeaderStyles() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "16px 24px",
      height: "100%",
      maxHeight: 56,
    },
    link: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 400,
      color: "#706E7A",
      "&:hover": {
        textDecoration: "none",
      },
    },
    breadcrumb: {
      gap: 8,
      alignItems: "center",
      display: "flex",
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 400,
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
